import { HtmlDocumentImporter } from "./html-document-importer";
import { getAfterInsertCallback, getAfterInsertReject } from "../../callback-helpers";
export function insertHtmlInSubDocument(processor, subDocument, position, htmlText, callback) {
    new HtmlDocumentImporter().importFromString(htmlText, processor.modelManager.richOptions, getAfterInsertCallback(processor, subDocument, position, callback), getAfterInsertReject(callback));
}
